import { render, staticRenderFns } from "./lk-leads-list.vue?vue&type=template&id=616862c4&"
import script from "./lk-leads-list.vue?vue&type=script&lang=js&"
export * from "./lk-leads-list.vue?vue&type=script&lang=js&"
import style0 from "./lk-leads-list.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-leads-list/lk-leads-list.vue
// module id = 1153
// module chunks = 0